import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import autobind from 'core-decorators/lib/autobind';
import i18n from '@wix/wix-vod-shared/src/common/i18n';
import Input from '@wix/wix-vod-shared/src/widget/ui-components/input/input';

import styles from './styles.styl';
import translations from 'messages/widget';

const HIDE_MESSAGE_TIMEOUT = 3000;


class CopyContent extends React.Component {

  static propTypes = {
    value: PropTypes.string,
    onInit: PropTypes.func,
    onFocus: PropTypes.func,
    onContentCopied: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      showSuccessMessage: false,
    };
  }

  componentDidMount() {
    this.props.onInit(this.input);
  }

  @autobind
  handleCopyClick() {
    const { showSuccessMessage } = this.state;
    if (!showSuccessMessage) {
      this.copyToClipboard();
    }
  }

  @autobind
  copyToClipboard() {
    if (document.queryCommandSupported('copy')) {
      this.input.select();
      document.execCommand('copy');
      this.setState({ showSuccessMessage: true });
      this.hideMessages();
      this.props.onContentCopied();
    }
  }


  hideMessages() {
   setTimeout(() => {
     this.setState({ showSuccessMessage: false });
   }, HIDE_MESSAGE_TIMEOUT);
  }

  @autobind
  setRef(node) {
    this.input = node;
  }

  render() {
    const { onFocus, value } = this.props;
    const { showSuccessMessage } = this.state;
    return (
      <div className={styles.copy}>
        <Input dataHook="iframe-code"
               className={styles['iframe-code']}
               setRef={this.setRef}
               onFocus={onFocus}
               value={value} />
        <button className={classNames(styles['copy-button'], { [styles.success]: showSuccessMessage })}
                tabIndex="0"
                onClick={this.handleCopyClick}>
          <i className={styles.checkmark} />
          <span className={styles.text}>
            {i18n.t(translations.embedCopy)}
          </span>
        </button>
      </div>
    );
  }
}


export default CopyContent;



// WEBPACK FOOTER //
// ./src/widget/containers/share-overlay/embed-form/copy-content/copy-content.js